"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../utils/validations");
const StreamMessage_1 = __importDefault(require("./StreamMessage"));
// TODO refactor deserialization to separate class (Serializer<GroupKeyMessage>)
class GroupKeyMessage {
    constructor(streamId, messageType) {
        validations_1.validateIsString('streamId', streamId);
        this.streamId = streamId;
        StreamMessage_1.default.validateMessageType(messageType);
        this.messageType = messageType;
    }
    serialize() {
        return JSON.stringify(this.toArray());
    }
    static deserialize(serialized, messageType) {
        if (!GroupKeyMessage.classByMessageType[messageType]) {
            throw new Error(`Unknown MessageType: ${messageType}`);
        }
        return GroupKeyMessage.classByMessageType[messageType].fromArray(JSON.parse(serialized));
    }
    static fromStreamMessage(streamMessage) {
        return GroupKeyMessage.deserialize(streamMessage.getSerializedContent(), streamMessage.messageType);
    }
    toStreamMessage(messageId, prevMsgRef) {
        return new StreamMessage_1.default({
            messageId,
            prevMsgRef,
            content: this.serialize(),
            messageType: this.messageType,
        });
    }
}
exports.default = GroupKeyMessage;
GroupKeyMessage.classByMessageType = {};
//# sourceMappingURL=GroupKeyMessage.js.map